
// src/actions/gamba-api.js

import AccessToken from './access-token'
import config from '../config'
import querystring from 'querystring'
import s3upload from './s3upload'
import each from 'lodash/each'

function _fetch(method, path, query, file, onprogress) {
  var url = config.baseApiUrl + path
  var body = null
  if (query) {
    switch(method) {
    case 'GET':
    case 'DELETE':
      if (query)
        url = `${url}?${querystring.stringify(query)}`
      break
    case 'POST':
    case 'PUT':
      if (file) {
        body = new FormData()
        body.append('file', file)
        each(query, (value, key)=> {
          body.append(key, value.toString())
        })
      }
      else {
        body = JSON.stringify(query)
      }
    }
  }

  return new Promise((resolve, reject)=> {
    AccessToken.get((token) => {
      var xhr = new XMLHttpRequest()
      xhr.open(method, url)

      //xhr.withCredentials = true
      xhr.setRequestHeader('Accept', 'application/json')
      !file && xhr.setRequestHeader('Content-Type', 'application/json')

      if (token)
        xhr.setRequestHeader('Authorization', token)

      xhr.onload = () => {
        try {
          var json = JSON.parse(xhr.responseText)
          if (json.status == 'ok')
            resolve(json.results)
          else {
            reject({ error: json.error, status: xhr.status })
          }
        } catch (e) {
          reject({ error: xhr.status == 503 && "error:unavailable" || "error:fetch_error", status: xhr.status })
        }
      }

      xhr.onabort = xhr.ontimeout = xhr.onerror = () => {
        reject({ error: xhr.status == 503 && "error:unavailable" || "error:fetch_error", status: xhr.status })
      }

      if (onprogress)
        xhr.onprogress = onprogress

      xhr.send(body)
    })
  })
}

export default {
  get: function (path, query = null) {
    return _fetch('GET', path, query, null)
  },

  post: function (path, query = null) {
    return _fetch('POST', path, query, null)
  },

  put: function (path, query = null) {
    return _fetch('PUT', path, query, null)
  },

  delete: function (path, query = null) {
    return _fetch('DELETE', path, query, null)
  },

  upload: function (path, query, file, onprogress) {
    return _fetch('POST', path, query, file, onprogress)
  },

  s3upload: s3upload,
}



// WEBPACK FOOTER //
// ./src/actions/gamba-api.js